import { LuSearch } from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "exportAdditionalinfoType",
            label: "Type",
            options: [
              { label: "Item Characteristics", value: "Item Characteristics" },
              { label: "Item Category", value: "Item Category" },
              { label: "Hand Carry", value: "Hand Carry" },
              { label: "Item Identification", value: "Item Identification" },
              { label: "Origin Criteria", value: "Origin Criteria" },
              { label: "PGA Exception category", value: "PGA Exception category",},
              { label: "Product Name", value: "Product Name" },
            ],
            component: "dropdown",
            endIconName: "LuChevronDown",
            placeholder: "Item Category",
             width : "50%",
          },
          {
            name: "exportAdditionalinfoQualifier",
            label: "Qualifier",
            dependsOn: "exportAdditionalinfoType",
            width : "50%",
            component: "dropdown",
            endIconName: "LuChevronDown",
            placeholder: "Food Supplement",
          },
        ],
        row2: [
          {
            name: "exportAdditionalinfoCode",
            label: "Code",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpointWithParams: "type",
            endpoint : "getQualifierCode", 
            useParams : "exportAdditionalinfoQualifier", 
            dependsOn: "exportAdditionalinfoQualifier",
            dependsValue: ["sex","storageCondition","drugRelatedCategory","foodsupplementproperty","gradeofproduct","labcoursecleared","plantCategory","plantParts","PQAException_PROD2016","PQAException_DCO2016","PlantCommodityName"],
          },
          {
            name: "exportAdditionalinfoInformation",
            label: "Information",
            component: "text-field",
            placeholder: "NA",
            dependsOn: "exportAdditionalinfoQualifier",
            dependsValue: ["breed","colour","plantVariety","sex","storageCondition","eticketnumber","passportnumber","pnrnumbeScientificNamer","animalpassportnumber","ElectronicComponet","chemicalabstrack","GlobalradeItemNumber","MicrochipsNumbersInsertedInto","VehicleIdentificationNumber","productSpecificRules","valueAdded","WhollyObtainedProducted","commonName","InternationalNonProprietaryName","NameasContainedinaPharmacopeia","NamePertheIUPACNomenclature","NameoftheLiveStockProduct","NameoftheModel","petname","PlantCommodityName","ScientificName","TradeorCommercialName",],
          },
        ],
        row3: [
          {
            name: "exportAdditionalinfoMeasure",
            label: "Measure",
            component: "text-field",
            placeholder: "1000.00",
            dataType: "int",
          },
          {
            name: "exportAdditionalinfoMeasureUnit",
            label: "Measure Unit",
            component: "text-field",
            placeholder: "Kg",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
      },
    },
  ],
};
